<template>
  <div>
    <hr class="w-full my-lg" />

    <div class="flex flex-wrap justify-between gap-base">
      <BaseButton
        v-if="back?.action"
        @click.native="back.action"
        :disabled="back.disabled"
        variant="secondary"
        :data-ec="buttonDataEc"
        :data-et="backButtonDataEt"
      >
        {{ back.label || backButtonLabel }}
      </BaseButton>

      <div class="contents sm:flex sm:flex-row-reverse sm:gap-lg sm:ml-auto">
        <BaseButton
          v-if="next?.action"
          @click.native="next.action"
          :disabled="next.disabled || next.busy"
          :loading="next.busy"
          class="ml-auto"
          :data-ec="buttonDataEc"
          :data-et="nextButtonDataEt"
        >
          {{ next.label || nextButtonLabel }}
        </BaseButton>

        <div class="flex justify-end w-full sm:contents">
          <BaseButton
            v-if="save?.action"
            @click.native="save.action"
            :disabled="save.disabled || save.busy"
            :loading="save.busy"
            variant="invisible"
            class="!px-0"
            :data-ec="buttonDataEc"
            data-et="save_draft_button"
          >
            {{ save.label || $t('ui.navigation.stepsNavigation.saveAsDraft') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';

import i18n from '@/locales';

import BaseButton from '@/components/library/buttons/BaseButton.vue';

/**
 * @typedef {object} Nav
 * @property {() => void} [action]
 * @property {string} [label]
 * @property {boolean} [busy]
 * @property {boolean} [disabled]
 */

const props = defineProps({
  /** @type import('vue').PropOptions<Nav> */
  back: {
    type: Object,
    required: false,
  },
  /** @type import('vue').PropOptions<Nav> */
  save: {
    type: Object,
    required: false,
  },
  /** @type import('vue').PropOptions<Nav> */
  next: {
    type: Object,
    required: false,
  },
  isEditRoute: {
    type: Boolean,
    required: false,
  },
  isEditStepRoute: {
    type: Boolean,
    required: false,
  },
  buttonDataEc: {
    type: String,
    required: true,
  },
});

const backButtonDataEt = computed(() =>
  (props.isEditRoute || props.isEditStepRoute ? 'cancel_button' : 'back_button'));
const nextButtonDataEt = computed(() =>
  (props.isEditRoute ? 'update_button' : 'next_button'));
const backButtonLabel = computed(() =>
  (props.isEditRoute || props.isEditStepRoute
    ? i18n.t('functional.cancel')
    : i18n.t('functional.back')));
const nextButtonLabel = computed(() =>
  (props.isEditRoute ? i18n.t('functional.update') : i18n.t('functional.next')));
</script>
